import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

import DropdownAutocomplete from 'components/DropdownAutocomplete';
import AdvancedDashboardSearch from 'components/Widget/components/menus/MainSettings/components/AdvancedDashboardSearch';
import { ThemeButton } from 'components/shared';
import Collapse from '@material-ui/core/Collapse';

const BenchmarkInput = memo(
  ({
    objectIdState,
    id,
    isOpen,
    options,
    handleBenchmarksObjectIdChange,
    handleAdvancedBenchmarkToggle,
    onBenchmarkChanged,
    disabled,
    isVisible
  }) => {
    const handleOpenAdvancedBenchmark = () => {
      handleAdvancedBenchmarkToggle(id);
    };

    const handleCloseAdvancedBenchmark = () => {
      handleAdvancedBenchmarkToggle();
    };
    if (!isVisible) {
      return null;
    }
    return (
      <>
        <Grid item xs={12} md={10}>
          <DropdownAutocomplete
            selected={objectIdState}
            options={options}
            onSelect={handleBenchmarksObjectIdChange}
            minWidth="220px"
            type={id}
            listBoxHeight="360px"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={2} md={2}>
          <ThemeButton
            id={id}
            themeColor={isOpen ? 'grey' : 'accent'}
            size="medium"
            onClick={isOpen ? handleCloseAdvancedBenchmark : handleOpenAdvancedBenchmark}
            disabled={disabled}
            fullWidth
          >
            {isOpen ? 'Hide' : 'Advanced'}
          </ThemeButton>
        </Grid>
        <Collapse in={isOpen}>
          <Grid item xs={12}>
            <AdvancedDashboardSearch
              index={id}
              onAccepted={onBenchmarkChanged}
              clearAdvancedView={handleCloseAdvancedBenchmark}
            />
          </Grid>
        </Collapse>
      </>
    );
  }
);
BenchmarkInput.propTypes = {
  objectIdState: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string
    })
  ).isRequired,
  handleBenchmarksObjectIdChange: PropTypes.func.isRequired,
  handleAdvancedBenchmarkToggle: PropTypes.func.isRequired,
  onBenchmarkChanged: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired
};

export default BenchmarkInput;
